import { render, staticRenderFns } from "./RegularVideoCard.vue?vue&type=template&id=3a5cea0c&scoped=true"
import script from "./RegularVideoCard.vue?vue&type=script&lang=js"
export * from "./RegularVideoCard.vue?vue&type=script&lang=js"
import style0 from "./RegularVideoCard.vue?vue&type=style&index=0&id=3a5cea0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5cea0c",
  null
  
)

export default component.exports